module.exports = __webpack_public_path__ + "static/media/DMSans_24pt-Bold.541d84af.ttf";